import React, { useContext } from "react";
import {
  SkeletonCardWrapper,
  SkeletonContent,
  SkeletonBoxAnimation
} from "./styles";
import { Context } from "@components/useContext/context";

const SkeletonCard = () => {
  const { isDesktop } = useContext(Context);
  return (
    <SkeletonCardWrapper>
      <SkeletonContent />
      <SkeletonContent />
      {/* <SkeletonContent /> */}
      {!isDesktop && (
        <>
          <SkeletonContent />
        </>
      )}
      <SkeletonBoxAnimation />
    </SkeletonCardWrapper>
  );
};

export default SkeletonCard;
